<template>
  <div class="container container-global">
    <h2>La contraception orale oestroprogestative</h2>
    <div class="content">
      <p>
        Association d’un oestrogène de synthèse (éthynilestradiol) ou oestrogène
        naturel à un progestatif de synthèse
      </p>
      <br />
      <span>Mode d’efficacité sur 3 niveaux </span>
      <ul>
        <li>
          axe hypothalomo-hypophysaire - action principale : effet antigonadrope
          =inhibition de la sécrétion des gonadotrophines et blocage de
          l’ovulation
        </li>
        <li>endomètre : atrophie de l’endomètre</li>
        <li>
          glaire cervicale : la glaire devient imperméable à la migration des
          spermatozoïdes
        </li>
      </ul>
      <span>Comment la prescrire ? </span>
      <br />
      <br />
      <p>
        Celles contenant du levonorgestrel ou du norgestimate sont recommandées
        en 1ère intention (recommandations CNGOF)
        <br />
        <br />
        Peut être prescrite en schéma discontinu (21 jours-arrêt 7 jours
        d'arrêt) ou en schéma continu.
        <br />
        <br />
        A initier classiquement au premier jour des règles.
        <br />
        <br />
        Quant au « quickstart », il consiste en une initiation à n’importe quel
        jour du cycle (en s’assurant de l’absence de grossesse), mais ne montre
        son efficacité qu’au bout du 7ème jour (méthodes barrières dans
        l’intervalle)
      </p>
      <br />
      <span>Efficacite</span>
      <br />
      <br />
      <p>Indice de Pearl 0,3% en vie réelle : 8%</p>
      <br />
      <span>Contre-indications absolues </span>
      <br />
      <br />
      <p>
        Accident thromboembolique veineux ou artériel (actuel ou antécédent)
        <br />
        Thrombophilie congénitale ou acquise Migraine avec aura quelque soit
        l’âge
        <br />
        Tabagisme après 35 ans
        <br />
        HTA non contrôlée
        <br />
        Diabète compliqué de micro ou macroangiopathie
        <br />
        Dyslipidémie sévère
        <br />
        Tumeurs hépatiques et hépatopathies sévères
        <br />
        Cancer estrogénodépendant
        <br />
        Allaitement maternel en cours
        <br />
        3 premières semaines du post partum
        <br />
        Risque de TEV et TEA
      </p>
      <br />
      <span>Effets secondaires les plus fréquents : </span>
      <ul>
        <li>
          Métrorragies (depuis plus de 3 mois sans cause organique retrouvée) 🡪
          augmenter la dose d’œstrogènes, modifier le type de progestatif
        </li>
        <li>
          Apparition d’une acné 🡪 switch par une contraception orale
          oestroprogestative avec un progrestatif anti-androgénique
          (norgestimate-dienogest-drospirénone) si persistance acné : avis
          dermatologique
        </li>
        <li>
          Si céphalées uniquement cataméniales : proposer schéma de prise en
          continu ou bien administration d’œstrogènes percutanés durant
          l’intervalle libre. Si apparition de céphalées sévères ou migraines
          avec aura : arrêt définitif de la COP
        </li>
        <li>Troubles gastro-intestinaux</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";

.container {
  margin-top: 37px;
  .content {
    margin-top: 15px;
    p {
      color: $text-color-aigm;
    }
    span {
      color: $dark-pink;
      text-decoration: underline;
    }
    ul {
      margin: 15px auto 15px auto;
      width: 90%;
      li {
        margin-top: 10px;
        color: $text-color-aigm;
      }
    }
  }
}
</style>
